<template>
  <div class="status-tag" :class="`${localType} ${size}`" :style="tagStyle">
    <span :style="labelStyle">{{ localLabel }}</span>
  </div>
</template>

<script>
export default {
  name: 'StatusTag',

  props: {
    tagStyle: {
      type: Object,
      default: () => {}
    },

    config: {
      type: Object,
      default: () => {}
    },

    type: {
      type: String,
      default: '',
      validator: function(value) {
        return ['', 'info', 'warning', 'primary', 'danger', 'success'].includes(
          value
        )
      }
    },

    label: {
      type: String,
      default: ''
    },

    labelStyle: {
      type: Object,
      default: () => {}
    },

    size: {
      type: String,
      default: 'medium',
      validator: function(value) {
        return ['', 'mini', 'small', 'medium'].includes(value)
      }
    }
  },

  computed: {
    localLabel() {
      return this.label || this.config?.label
    },

    localType() {
      return this.type || this.config?.type
    }
  }
}
</script>

<style lang="scss" scoped>
.status-tag {
  display: flex;
  align-items: center;
  color: $text-color;
  span {
    color: $text-color;
  }

  &.info {
    color: $info-color;
    &::before {
      background-color: $info-color;
    }
  }
  &.primary {
    color: $primary-color;
    &::before {
      background-color: $primary-color;
    }
  }
  &.danger {
    color: $danger-color;
    &::before {
      background-color: $danger-color;
    }
  }
  &.warning {
    color: $warning-color;
    &::before {
      background-color: $warning-color;
    }
  }
  &.success {
    color: $success-color;
    &::before {
      background-color: $success-color;
    }
  }

  &.medium {
    font-size: 20px;
  }

  &.small {
    font-size: 14px;
  }
  &.mini {
    font-size: 12px;
  }

  &::before {
    content: ' ';
    display: inline-block;
    border-radius: 50%;
    color: inherit;
    background-color: inherit;
  }
  &.medium::before {
    width: 8px;
    height: 8px;
    margin-right: 8px;
  }
  &.small::before {
    width: 6px;
    height: 6px;
    margin-right: 8px;
  }
  &.mini::before {
    width: 6px;
    height: 6px;
    margin-right: 4px;
  }
}
</style>
